import React, { useContext } from "react";
import { Navigate } from "react-router";
import LoginForm from "../../components/forms/loginForm/LoginForm";
import MobileFooter from "../../components/mobileFooter/MobileFooter";
import { AuthContext } from "../../services/context/authContext/AuthContext";
import { loginStyles } from "../../theme/theme";

const Login = () => {
  const user = useContext(AuthContext);

  if (user) {
    return <Navigate to="/" />;
  }

  return (
    <div className={loginStyles["background"]}>
      <div className={loginStyles["cardContainer"]}>
        <div className={loginStyles["formContainer"]}>
          <LoginForm />
        </div>
      </div>
      <MobileFooter />
    </div>
  );
};

export default Login;
